module.exports = __webpack_public_path__ + "img/fcd0e38450f43464855c0de8d972a4eb.gif";